import { Radio } from "@mui/material";
import FormatAmount from "../../../../_utils/FormatAmount/FormatAmount";
import AmountInputField from "../../../../_utils/CommonInputFields/AmountInputField";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";

/**
 * @typedef {Object} CopyData
 * @property {string} title - Title of the data to copy (e.g., "Transfer Amount")
 * @property {string} data_type - Type of data (e.g., "numeric")
 * @property {string} icon - Icon to show for the paste action
 * @property {string|number} value - The value to be pasted
 */

/**
 * @typedef {Object} TxnPayLoad
 * @property {string|number} amount - The transaction amount
 * @property {string} amountWords - The amount converted to words
 */

/**
 * @typedef {Object} AmountProps
 * @property {string} title - Section title (default: "Amount")
 * @property {string|number} amount - Current entered amount (default: "")
 *
 * @property {CopyData} copyData - Details for paste functionality (default: {})
 * @property {Function} onAmountChange - Called on amount change (default: () => {})
 * @property {Function} onPasteApplied - Called after paste action (default: () => {})
 *
 * @property {boolean} [isPreview=false] - Shows static summary card
 * @property {TxnPayLoad} txnPayLoad - Payload used in preview mode (default: {})
 */

const TransactionLimit = ({
  title,
  amount,
  copyData,
  onAmountChange,
  onPasteApplied,
  handleRadioBtn,
  selectedRadioValue,
  NewAmount,
  handleDivBtn,
  CustomamountRequired = false,
}) => {
  const pasteAvailable =
    copyData?.title === "Transfer amount" || copyData?.data_type === "numeric";

  return (
    <div className="w-width-full max-h-auto">
      <div className="w-width-full h-fit">
        <div className="flex flex-col relative">
          <div className="p-padding-md h-height-full bg-primary-card flex flex-col rounded-border-radius-md">
            <div className="pb-padding-md">
              <p className="text-text-primary text-font-md font-semibold">
                24 Hour Transaction Limit
              </p>
              <p className="text-text-secondary mt-margin-xs text-xs">
                The 24 hour transaction limit for each account.
              </p>
            </div>
            <AmountInputField
              name="amount"
              value={amount}
              placeholder="Amount"
              bgColor="var(--primary-card   )"
              fgColor="var(--text-primary)"
              isFullWidth={true}
              isDisabled={false}
              adornment={pasteAvailable ? copyData?.icon : ""}
              onInput={(val) => onAmountChange(val)}
              onAdornmentClick={
                pasteAvailable
                  ? () => {
                      onAmountChange(copyData?.value?.toString?.() || "");
                      onPasteApplied();
                    }
                  : undefined
              }
            />

            {CustomamountRequired && (
              <div className="flex flex-col gap-gap-md">
                <div
                  className={`flex flex-row items-center w-width-full mt-margin-md rounded-border-radius-md p-padding-sm mobile-account-name-div  ${
                    selectedRadioValue === "defaultAmount"
                      ? "bg-text-primary cursor-default"
                      : "bg-primary-nav cursor-pointer global-hover-white relative z-z-index-base"
                  }`}
                  onClick={() => {
                    handleDivBtn("defaultAmount");
                  }}
                >
                  <Radio
                    checked={selectedRadioValue === "defaultAmount"}
                    onChange={handleRadioBtn}
                    value="defaultAmount"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "B" }}
                    sx={{
                      "& .MuiSvgIcon-root": {
                        width: "var(--icon-md)",
                        height: "var(--icon-md)",
                      },
                      "color":
                        selectedRadioValue === "defaultAmount"
                          ? "var(--positive-act)"
                          : "var(--text-primary)",
                      "&.Mui-checked": {
                        color:
                          selectedRadioValue === "defaultAmount"
                            ? "var(--positive-act)"
                            : "var(--text-primary)",
                      },
                      "padding": "var(--padding-base) var(--padding-sm)",
                    }}
                  />
                  <div className="flex flex-col">
                    <div
                      className={`text-font-sm font-semibold truncate ${
                        selectedRadioValue === "defaultAmount"
                          ? "text-primary-bg"
                          : "text-text-primary"
                      }`}
                    >
                      <div className="flex ">
                        <span>INR</span>
                        <p className="ml-margin-xs ">
                          <FormatAmount
                            price={GlobalConfiguration.defaultAmount}
                          />
                        </p>
                      </div>
                    </div>
                    <p
                      className={`text-font-xs font-normal truncate  ${
                        selectedRadioValue === "defaultAmount"
                          ? "text-text-disabled"
                          : "text-text-secondary"
                      }`}
                    >
                      Default transaction limit
                    </p>
                  </div>
                </div>
                <div
                  className={`flex flex-row items-center w-width-full  rounded-border-radius-md p-padding-sm mobile-account-name-div ${
                    selectedRadioValue === "customAmount"
                      ? "bg-text-primary cursor-default"
                      : "bg-primary-nav cursor-pointer global-hover-white relative z-z-index-base"
                  }`}
                  onClick={() => {
                    handleDivBtn("customAmount");
                  }}
                >
                  <Radio
                    checked={selectedRadioValue === "customAmount"}
                    onChange={handleRadioBtn}
                    value="customAmount"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "B" }}
                    sx={{
                      "& .MuiSvgIcon-root": {
                        width: "var(--icon-md)",
                        height: "var(--icon-md)",
                      },
                      "color":
                        selectedRadioValue === "customAmount"
                          ? "var(--positive-act)"
                          : "var(--text-primary)",
                      "&.Mui-checked": {
                        color:
                          selectedRadioValue === "customAmount"
                            ? "var(--positive-act)"
                            : "var(--text-primary)",
                      },
                      "padding": "var(--padding-base) var(--padding-sm)",
                    }}
                  />
                  <div className="flex flex-col">
                    <div
                      className={`text-font-sm font-semibold truncate ${
                        selectedRadioValue === "customAmount"
                          ? "text-primary-bg"
                          : "text-text-primary"
                      }`}
                    >
                      Custom limit
                    </div>
                    <p
                      className={`text-font-xs font-normal truncate ${
                        selectedRadioValue === "customAmount"
                          ? "text-text-disabled"
                          : "text-text-secondary"
                      }`}
                    >
                      Custom transaction limit
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionLimit;
